<div class="matrix_layoutMain container"  v-bind:class="getClassNameContainer">
    <div class="row">
        <div class="col-md-12" >                
            <appCostCenter></appCostCenter>
            <appQuantityTable v-if="!getCimpressNoQuantity">
                <appQuantityContainer></appQuantityContainer>
                <appInputQuantity></appInputQuantity>
            </appQuantityTable>
            <appOtherOptionsTable>
                <appOtherOptionsContainer></appOtherOptionsContainer>
            </appOtherOptionsTable>
            <appOptionsTable>
                <appOptionsContainer></appOptionsContainer>
                <appInputCustomFormatInsert></appInputCustomFormatInsert>
            </appOptionsTable>
            <appQuantityTable v-if="getCimpressNoQuantity">
                <appQuantityContainer></appQuantityContainer>
                <appInputQuantity></appInputQuantity>
            </appQuantityTable>
            <appUploadTable alwaysShow=true></appUploadTable>
            <div class="matrix_summaryInformation">
                <appFactsheet></appFactsheet>
            </div>
            <appPersonalizationButton v-show="getPersonalizationFullPage"></appPersonalizationButton>              
            <appAddToCartButton v-show="getAddToCartFullPage"></appAddToCartButton>  
            <appQuotationButton></appQuotationButton>  
        </div>
    </div>    
</div>